import styles from './SummaryBox.module.scss';

interface SummaryBoxProps {
  label: string;
  value: string;
  ariaBusy?: boolean;
  testId?: string;
}

export const SummaryBox: React.FC<SummaryBoxProps> = ({ label, value, ariaBusy, testId }) => (
  <dl className={styles.box} data-testid={testId} aria-busy={ariaBusy}>
    <dt className={styles.label}>{label}</dt>
    <dd className={styles.value} data-testid={testId ? `${testId}-value` : undefined}>
      {value}
    </dd>
  </dl>
);
